module.exports = __webpack_public_path__ + "img/skill-4.c045e475.svg";